import { OptionedProductSelection } from 'services/api/entities/events/types/internal/selections'
import { yupArray, YupSchema } from 'services/yup'
import { optionGroupSelectionVS } from '../options'
import { mainProductWithUpsellingSelectionVS } from './mainProductWithUpselling'

export const optionedProductSelectionVS: YupSchema<OptionedProductSelection> =
  mainProductWithUpsellingSelectionVS.shape({
    optionSelections: yupArray(optionGroupSelectionVS),
  })
